<div *ngIf="(hospitalInvoiceMasterData || schoolInvoiceMasterData) && !isInvoiceAlreadyPaid" style="padding: 20px">
  <div
    class="top-bar d-flex align-items-center justify-content-between pt-2 pb-1 mb-1"
  >
    <div class="flex-grow-1">
      <h2 class="mb-0"><i class="bi bi-wallet2"></i> Pay Now</h2>
    </div>
  </div>

  <!-- MAIN CONTENT -->
  <div class="container-fluid px-2 py-1">
    <div class="row g-4">
      <!-- LEFT SIDE -->
      <div class="col-lg-5">
        <div class="glass-card h-100 p-4 p-md-5">
          <!-- ── TOTAL PAYMENT HEADER ── -->
          <h3 class="fw-bold mb-3"><strong>Total Payment</strong></h3>

          <!-- ── AMOUNT DISPLAY CARD ── -->
          <div class="amount-display-card mb-4">
            <div class="amount-label">Transaction Amount</div>
            <div class="amount-value">
              <i class="fa-solid fa-indian-rupee-sign rupee-icon"></i>
              <span class="amount-number">{{ quickLoanData.loanamt }}</span>
            </div>
            <div class="amount-badge">
              <i class="bi bi-shield-check-fill me-1"></i> Secured Payment
            </div>
          </div>

          <!-- ── PAYMENT METHOD SELECTION ── -->
          <p class="pay-method-title mb-3">Choose Payment Method</p>

          <div class="payment-methods-grid mb-4">
            <!-- Pay via Nishwik -->
            <label
              class="pay-method-card nishwik-card highlight-nishwik"
              [class.active]="selectedPaymentMethod === 'NISHWIK'"
              (click)="selectPayment('NISHWIK')"
            >
              <input
                type="radio"
                name="payMethod"
                value="NISHWIK"
                [(ngModel)]="selectedPaymentMethod"
                hidden
              />

              <div class="pay-method-icon nishwik-icon">
                <img src="assets/images/Logo.svg" class="nishwik-logo" />
              </div>

              <span class="pay-method-label">
                Pay via <strong>Nishwik</strong>
              </span>

              <div class="pay-method-check">
                <i class="bi bi-check-circle-fill"></i>
              </div>

              <div class="nishwik-badge">Recommended</div>
            </label>

            <!-- UPI -->
            <!-- <label
              class="pay-method-card"
              [class.active]="selectedPaymentMethod === 'UPI'"
              (click)="selectPayment('UPI')"
            >
              <input
                type="radio"
                name="payMethod"
                value="UPI"
                [(ngModel)]="selectedPaymentMethod"
                hidden
              />

              <div class="pay-method-icon upi-icon">
                <svg width="28" height="28" viewBox="0 0 40 40">
                  <rect width="40" height="40" rx="8" fill="#5F259F" />
                  <text
                    x="50%"
                    y="58%"
                    text-anchor="middle"
                    fill="white"
                    font-size="12"
                    font-weight="700"
                  >
                    UPI
                  </text>
                </svg>
              </div>

              <span class="pay-method-label">UPI</span>

              <div class="pay-method-check">
                <i class="bi bi-check-circle-fill"></i>
              </div>
            </label> -->

            <!-- Credit Card -->
            <!-- <label
              class="pay-method-card"
              [class.active]="selectedPaymentMethod === 'CREDIT'"
              (click)="selectPayment('CREDIT')"
            >
              <input
                type="radio"
                name="payMethod"
                value="CREDIT"
                [(ngModel)]="selectedPaymentMethod"
                hidden
              />

              <div class="pay-method-icon credit-icon">
                <i class="bi bi-credit-card-2-front-fill"></i>
              </div>

              <span class="pay-method-label">Credit Card</span>

              <div class="pay-method-check">
                <i class="bi bi-check-circle-fill"></i>
              </div>
            </label> -->

            <!-- Debit Card -->
            <!-- <label
              class="pay-method-card"
              [class.active]="selectedPaymentMethod === 'DEBIT'"
              (click)="selectPayment('DEBIT')"
            >
              <input
                type="radio"
                name="payMethod"
                value="DEBIT"
                [(ngModel)]="selectedPaymentMethod"
                hidden
              />

              <div class="pay-method-icon debit-icon">
                <i class="bi bi-credit-card-fill"></i>
              </div>

              <span class="pay-method-label">Debit Card</span>

              <div class="pay-method-check">
                <i class="bi bi-check-circle-fill"></i>
              </div>
            </label> -->

            <!-- Cash -->
            <label
              class="pay-method-card"
              [class.active]="selectedPaymentMethod === 'CASH'"
              (click)="selectPayment('CASH')"
            >
              <input
                type="radio"
                name="payMethod"
                value="CASH"
                [(ngModel)]="selectedPaymentMethod"
                hidden
              />

              <div class="pay-method-icon cash-icon">
                <i class="bi bi-cash-stack"></i>
              </div>

              <span class="pay-method-label">Cash</span>

              <div class="pay-method-check">
                <i class="bi bi-check-circle-fill"></i>
              </div>
            </label>
          </div>

          <!-- ── RAZORPAY BUTTON (shown for UPI / Credit / Debit) ── -->
          <div
            *ngIf="remainingAmount > 0 && selectedPaymentMethod !== 'NISHWIK'"
            class="mb-3"
          >
            <app-razorpay></app-razorpay>
          </div>

          <!-- ── NISHWIK LOAN BUTTON ── -->
          <div
            *ngIf="remainingAmount > 0 && selectedPaymentMethod === 'NISHWIK'"
            class="mb-3"
          >
            <button
              class="btn nishwik-pay-btn w-100 fw-bold d-flex align-items-center justify-content-center gap-2"
              [disabled]="!isAmountWithinLoanLimits() || isLoading"
            >
              <div
                *ngIf="isLoading"
                class="spinner-border spinner-border-sm text-light"
                role="status"
              >
                <span class="visually-hidden">Loading...</span>
              </div>
              <i *ngIf="!isLoading" class="bi bi-lightning-charge-fill"></i>
              <span *ngIf="!isLoading">Pay via Nishwik</span>
              <span *ngIf="isLoading">Processing...</span>
            </button>
          </div>

          <!-- ── TRUST INFO CARD ── -->
          <div class="info-card">
            <strong>💡 Tip</strong>
            <p>
              Choose EMI to reduce upfront payment and manage your expenses
              better.
            </p>
            <div class="trust-box">
              <ul>
                <li>🔒 100% Secure Payments</li>
                <li>⚡ Instant Confirmation</li>
                <li>📞 24x7 Customer Support</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT SIDE -->
      <div class="col-lg-7">
        <div class="glass-card h-100 p-3" #emiSection>
          <h4 class="mb-2"><strong>Payment Details</strong></h4>

          <!-- ================= UPI ================= -->
          <div *ngIf="activeTab === 'UPI'" class="tab-box p-3">
            <h6 class="mb-2">Pay via UPI</h6>

            <input
              type="text"
              class="form-control form-control-sm mb-2"
              placeholder="Enter UPI ID (example@upi)"
              [(ngModel)]="upiId"
              (input)="upiVerified = false; upiError = false"
              [ngClass]="{
                'is-valid': upiVerified,
                'is-invalid': upiError,
              }"
            />

            <input
              type="number"
              class="form-control form-control-sm mb-2"
              placeholder="Enter Amount"
              [(ngModel)]="manualAmount"
            />

            <div *ngIf="upiVerified" class="text-success small fw-bold">
              ✅ Verified
            </div>

            <div *ngIf="upiError" class="text-danger small fw-bold">
              ❌ Invalid UPI ID
            </div>
          </div>

          <!-- ================= CREDIT CARD ================= -->
          <div *ngIf="activeTab === 'CREDIT'" class="tab-box p-3">
            <h6 class="mb-2">Credit Card</h6>

            <input
              class="form-control form-control-sm mb-2"
              placeholder="Card Number"
              [(ngModel)]="cardDetails.number"
            />

            <div class="d-flex gap-2 mb-2">
              <input
                class="form-control form-control-sm"
                placeholder="MM/YY"
                [(ngModel)]="cardDetails.expiry"
              />

              <input
                class="form-control form-control-sm"
                placeholder="CVV"
                [(ngModel)]="cardDetails.cvv"
              />
            </div>

            <input
              type="number"
              class="form-control form-control-sm mb-2"
              placeholder="Enter Amount"
              [(ngModel)]="manualAmount"
            />

            <div class="fw-bold small">₹{{ quickLoanData.loanamt }}</div>
          </div>

          <!-- ================= DEBIT CARD ================= -->
          <div *ngIf="activeTab === 'DEBIT'" class="tab-box p-3">
            <h6 class="mb-2">Debit Card</h6>

            <input
              class="form-control form-control-sm mb-2"
              placeholder="Card Number"
              [(ngModel)]="cardDetails.number"
            />

            <div class="d-flex gap-2 mb-2">
              <input
                class="form-control form-control-sm"
                placeholder="MM/YY"
                [(ngModel)]="cardDetails.expiry"
              />

              <input
                class="form-control form-control-sm"
                placeholder="CVV"
                [(ngModel)]="cardDetails.cvv"
              />
            </div>

            <input
              type="number"
              class="form-control form-control-sm mb-2"
              placeholder="Enter Amount"
              [(ngModel)]="manualAmount"
            />

            <div class="fw-bold small">₹{{ quickLoanData.loanamt }}</div>
          </div>

          <!-- ================= CASH ================= -->
          <div *ngIf="activeTab === 'CASH'" class="tab-box p-3">
            <h6 class="mb-2">Cash Payment</h6>

            <!-- <input
            class="form-control form-control-sm mb-2"
            placeholder="Enter Name"
            [(ngModel)]="cashDetails.name"
          /> -->

            <!-- <input
            type="number"
            class="form-control form-control-sm mb-2"
            placeholder="Enter Amount"
            [(ngModel)]="manualAmount"
          /> -->

            <div class="fw-bold small">₹{{ quickLoanData.loanamt }}</div>

            <p class="text-muted small mb-0">Pay at counter</p>
          </div>

          <!-- ================= NISHWIK EMI ================= -->
          <div *ngIf="activeTab === 'NISHWIK'" class="p-2">
            <h5 class="mb-2"><strong>Plan EMI</strong></h5>

            <!-- Compact Inputs -->
            <!-- <div class="row g-2 mb-2">
            <div class="col-md-4">
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="Amount"
                [(ngModel)]="manualAmount"
              />
            </div>

            <div class="col-md-4">
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="Interest %"
                [(ngModel)]="manualInterest"
              />
            </div>

            <div class="col-md-4">
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="Discount %"
                [(ngModel)]="manualDiscount"
              />
            </div>
          </div> -->

            <!-- Scrollable EMI LIST -->
            <div class="pe-1" *ngIf="!isLoanSlabLoaded">
              <!-- Header -->
              <div
                class="card-emi px-2 py-1 mb-1 d-flex justify-content-between small fw-bold bg-light"
              >
                <div style="width: 35%">EMI</div>
                <!-- <div style="width: 20%" class="text-center">Disc</div> -->
                <div style="width: 20%" class="text-center">Int</div>
                <div style="width: 25%" class="text-end">Total</div>
              </div>

              <!-- EMI ITEMS -->
              <div class="mb-1" *ngFor="let key of monthColumns">
                <label class="w-100">
                  <div
                    class="card-emi px-2 py-2 d-flex justify-content-between align-items-center small"
                  >
                    <!-- EMI -->
                    <div
                      class="d-flex align-items-center gap-2"
                      style="width: 35%"
                    >
                      <input
                        type="radio"
                        class="form-check-input"
                        [value]="key"
                        [(ngModel)]="selectedMonth"
                        (change)="calculateEmi()"
                      />

                      <div>
                        <h5 class="fw-bold mb-0">
                          ₹{{ getValue("EMI", key) | number: "1.0-2" }}/mo
                        </h5>
                        <small class="text-muted">for {{ key }} months</small>
                      </div>
                    </div>

                    <!-- Discount -->
                    <!-- <div>
                      <small class="text-muted d-block">Amount</small>
                      <strong>₹{{ getValue("Amount", key) | number }}</strong>
                    </div> -->

                    <!-- Interest -->
                    <div>
                      <small class="text-muted d-block">Interest/Month</small>
                      <strong
                        >₹{{
                          getValue("Interest", key) | number: "1.3-3"
                        }}</strong
                      >
                    </div>

                    <!-- Total -->
                    <div>
                      <small class="text-muted d-block">Total Payable</small>
                      <strong
                        >₹{{
                          getValue("Total Payable", key) | number: "1.0-2"
                        }}</strong
                      >
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <!-- PAY NOW / APPLY FOR LOAN -->
          <div class="mt-2">
            <!-- Show for all tabs EXCEPT NISHWIK -->

<ng-container *ngIf="activeTab !== 'NISHWIK'">
  <ng-container *ngIf="shouldShowPayNow; else closePaymentButton">
    <button
      type="button"
      class="btn pay-now-btn w-100 py-2"
      (click)="handlePayment()"
      [disabled]="isLoading"
    >
      <span *ngIf="!isLoading">Pay Now</span>
      <span *ngIf="isLoading">Processing...</span>
    </button>
  </ng-container>

  <ng-template #closePaymentButton>
    <button
      type="button"
      class="btn pay-now-btn w-100 py-2"
      (click)="goBack()"
    >
      Close
    </button>
  </ng-template>
</ng-container>
            <!-- Show ONLY for NISHWIK tab -->
            <button
              *ngIf="activeTab === 'NISHWIK'"
              class="btn pay-now-btn w-100 py-2"
              (click)="applyForLoan()"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading">Apply for Loan</span>
              <span *ngIf="isLoading">Processing...</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- BOTTOM FEATURES -->
    <div class="glass-card mt-4 p-5 text-center">
      <div *ngIf="loanProduct">
        <h2 class="fw-bold mb-2">
          Nishwik Payment Solution:
          <span style="color: #d00162">{{ loanProduct.productName }}</span>
        </h2>
        <p class="text-muted mb-5">{{ loanProduct.description }}</p>
      </div>

      <div class="row text-center g-4">
        <div class="col-6 col-lg">
          <div class="feature-icon mx-auto mb-2">
            <img
              src="assets\images\paynow\EasyEMI.png"
              alt="Easy EMI"
              class="icon-img"
            />
          </div>
          <p class="fw-semibold">Pay in Easy EMIs</p>
        </div>

        <div class="col-6 col-lg">
          <div class="feature-icon mx-auto mb-2">
            <img
              src="assets\images\paynow\Instant.png"
              alt="Instant Approval"
              class="icon-img"
            />
          </div>
          <p class="fw-semibold">Instant Approval</p>
        </div>

        <div class="col-6 col-lg">
          <div class="feature-icon mx-auto mb-2">
            <img
              src="assets\images\paynow\Zerocollateral.png"
              alt="Zero Collateral"
              class="icon-img"
            />
          </div>
          <p class="fw-semibold">Zero Collateral</p>
        </div>

        <div class="col-6 col-lg">
          <div class="feature-icon mx-auto mb-2">
            <img
              src="assets\images\paynow\customerfriendly.png"
              alt="Customer-Friendly Process"
              class="icon-img"
            />
          </div>
          <p class="fw-semibold">Customer-Friendly Process</p>
        </div>

        <div class="col-6 col-lg">
          <div class="feature-icon mx-auto mb-2">
            <img
              src="assets\images\paynow\Payment.png"
              alt="Hassle-Free Payments"
              class="icon-img"
            />
          </div>
          <p class="fw-semibold">Hassle-Free Payments</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- confirmation model -->
<div></div>

<!-- payment done confirmation message -->
<div class="payment-done-wrapper" *ngIf="hospitalInvoiceMasterData && isInvoiceAlreadyPaid" style="padding: 20px">
  <!-- Background decorative circles -->
  <div class="bg-circle bg-circle--1"></div>
  <div class="bg-circle bg-circle--2"></div>

  <div class="payment-done-container">
    <!-- Animated check icon -->
    <div class="check-wrap">
      <svg
        class="check-svg"
        viewBox="0 0 90 90"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle class="check-bg" cx="45" cy="45" r="42" />
        <circle class="check-ring" cx="45" cy="45" r="42" />
        <path class="check-mark" d="M26 45 L39 58 L64 32" />
      </svg>
    </div>

    <!-- Status badge -->
    <div class="status-badge">
      <span class="badge-dot"></span>
      Payment Completed
    </div>

    <!-- Heading -->
    <h1 class="main-title">Invoice already paid</h1>
    <p class="sub-text">
      This invoice has been successfully settled and is no longer available for
      payment processing.
    </p>

    <!-- Invoice card -->
    <div class="invoice-card">
      <div class="card-header">
        <span class="card-header-label">Invoice summary</span>
        <span class="invoice-num-badge">{{
          hospitalInvoiceMasterData.invoiceNumber
        }}</span>
      </div>

      <div class="card-body">
        <div class="info-row">
          <span class="info-label">Patient name</span>
          <span class="info-value">{{
            hospitalInvoiceMasterData.patientName
          }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Invoice date</span>
          <span class="info-value">{{
            hospitalInvoiceMasterData.invoiceDate | date: "dd MMM yyyy"
          }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Due date</span>
          <span class="info-value">{{
            hospitalInvoiceMasterData.dueDate | date: "dd MMM yyyy"
          }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Status</span>
          <span class="info-value info-value--green">{{
            hospitalInvoiceMasterData.status
          }}</span>
        </div>
      </div>

      <div class="amount-row">
        <span class="amount-label">Total amount paid</span>
        <span class="amount-value"
          >₹{{
            hospitalInvoiceMasterData.invoiceAmount | number: "1.2-2"
          }}</span
        >
      </div>
    </div>

    <!-- Notice box -->
    <div class="notice-box">
      <svg
        class="notice-icon"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="8" cy="8" r="7" stroke="#16a34a" stroke-width="1.2" />
        <path
          d="M8 7v4"
          stroke="#16a34a"
          stroke-width="1.4"
          stroke-linecap="round"
        />
        <circle cx="8" cy="5" r="0.6" fill="#16a34a" />
      </svg>
      <p class="notice-text">
        This invoice has been processed and closed. If you believe this is an
        error or need a duplicate receipt, please contact your hospital billing
        department.
      </p>
    </div>

    <!-- PRRN chip -->
    <div class="prrn-chip">
      <span class="prrn-label">PRRN</span>
      <span class="prrn-value">{{ hospitalInvoiceMasterData.prrn }}</span>
    </div>
  </div>
</div>

<div class="payment-done-wrapper" *ngIf="schoolInvoiceMasterData && isInvoiceAlreadyPaid" style="padding: 20px">
  <!-- Background decorative circles -->
  <div class="bg-circle bg-circle--1"></div>
  <div class="bg-circle bg-circle--2"></div>

  <div class="payment-done-container">
    <!-- Animated check icon -->
    <div class="check-wrap">
      <svg
        class="check-svg"
        viewBox="0 0 90 90"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle class="check-bg" cx="45" cy="45" r="42" />
        <circle class="check-ring" cx="45" cy="45" r="42" />
        <path class="check-mark" d="M26 45 L39 58 L64 32" />
      </svg>
    </div>

    <!-- Status badge -->
    <div class="status-badge">
      <span class="badge-dot"></span>
      Payment Completed
    </div>

    <!-- Heading -->
    <h1 class="main-title">Invoice already paid</h1>
    <p class="sub-text">
      This invoice has been successfully settled and is no longer available for
      payment processing.
    </p>

    <!-- Invoice card -->
    <div class="invoice-card">
      <div class="card-header">
        <span class="card-header-label">Invoice summary</span>
        <span class="invoice-num-badge">{{
          schoolInvoiceMasterData.invoiceNumber
        }}</span>
      </div>

      <div class="card-body">
        <div class="info-row">
          <span class="info-label">Invoice date</span>
          <span class="info-value">{{
            schoolInvoiceMasterData.invoiceDate | date: "dd MMM yyyy"
          }}</span>
        </div>
        <!-- <div class="info-row">
          <span class="info-label">Due date</span>
          <span class="info-value">{{
            hospitalInvoiceMasterData.dueDate | date: "dd MMM yyyy"
          }}</span>
        </div> -->
        <div class="info-row">
          <span class="info-label">Status</span>
          <span class="info-value info-value--green">{{
            schoolInvoiceMasterData.status
          }}</span>
        </div>
      </div>

      <div class="amount-row">
        <span class="amount-label">Total amount paid</span>
        <span class="amount-value"
          >₹{{
            schoolInvoiceMasterData.invoiceAmount | number: "1.2-2"
          }}</span
        >
      </div>
    </div>

    <!-- Notice box -->
    <div class="notice-box">
      <svg
        class="notice-icon"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="8" cy="8" r="7" stroke="#16a34a" stroke-width="1.2" />
        <path
          d="M8 7v4"
          stroke="#16a34a"
          stroke-width="1.4"
          stroke-linecap="round"
        />
        <circle cx="8" cy="5" r="0.6" fill="#16a34a" />
      </svg>
      <p class="notice-text">
        This invoice has been processed and closed. If you believe this is an
        error or need a duplicate receipt, please contact your hospital billing
        department.
      </p>
    </div>

    <!-- PRRN chip -->
    <div class="prrn-chip">
      <span class="prrn-label">PRRN</span>
      <span class="prrn-value">{{ schoolInvoiceMasterData.prrn }}</span>
    </div>
  </div>
</div>
